export default "__VITE_ASSET__COoMMP3f__"